package diana.soleil.design.iraniancanadienbazzar.feature.marketplace

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import kotlinx.coroutines.launch
import androidx.compose.runtime.rememberCoroutineScope
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.CityField
import diana.soleil.design.iraniancanadienbazzar.core.model.Metros
import diana.soleil.design.iraniancanadienbazzar.core.model.PickedImage
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import diana.soleil.design.iraniancanadienbazzar.core.model.Language
import diana.soleil.design.iraniancanadienbazzar.core.model.Deal
import diana.soleil.design.iraniancanadienbazzar.core.model.Business
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.IconBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.FeaturedBusinessCard
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Brush
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import org.jetbrains.compose.resources.decodeToImageBitmap
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.tooling.preview.Preview
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBanner
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.PersonAvatar
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppConfirmDialog
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppTextField
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BusinessCover
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.MarketItemRailCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ErrorState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.MediaCardSkeleton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.MarketplaceItemCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportReason
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportStatus
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SectionHeader
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.StatusBadge
import diana.soleil.design.iraniancanadienbazzar.core.common.ShareService
import diana.soleil.design.iraniancanadienbazzar.core.data.ShareConfig
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.WindowWidthClass
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.windowWidthClassFor
import diana.soleil.design.iraniancanadienbazzar.core.model.formatCount
import diana.soleil.design.iraniancanadienbazzar.core.model.Country
import diana.soleil.design.iraniancanadienbazzar.core.model.ItemCondition
import diana.soleil.design.iraniancanadienbazzar.core.model.MarketplaceCategory
import diana.soleil.design.iraniancanadienbazzar.core.model.ItemStatus
import diana.soleil.design.iraniancanadienbazzar.core.model.MarketplaceItem
import diana.soleil.design.iraniancanadienbazzar.core.model.formatPriceCents
import diana.soleil.design.iraniancanadienbazzar.core.model.cityLabel
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_time_just_now
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_time_minutes_ago
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_time_hours_ago
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_time_days_ago
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_time_weeks_ago
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_add_photo
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_photos_label
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_photo_main
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_photo_remove
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_category_label
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_cat_all
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_cat_furniture
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_cat_electronics
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_cat_home_kitchen
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_cat_appliances
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_cat_clothing
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_cat_kids
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_cat_books
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_cat_vehicles
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_cat_sports
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_cat_other
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_add_photo_failed
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_photo_upload_warning
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_photo_upload_warning_dismiss
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_all
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_edit
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_delete_action
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_delete_confirm
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_delete_failed
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_edit_action
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_edit_failed
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_edit_save
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_mark_sold
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_mark_sold_cancel
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_mark_sold_confirm
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_mark_sold_failed
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_my_listings
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_save_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_saved
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_featured_section
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_saved_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sold_note
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_status_sold
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_city_label
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_city_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_condition_label
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_cta
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_desc_label
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_desc_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_free
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_price_label
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_price_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_publish
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_title_label
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_title_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_condition
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_condition_like_new
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_condition_new
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_condition_used
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_description
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_empty_description
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_empty_title
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_error
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_free
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_image_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_item_description
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_location
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_message_seller
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_message_seller_failed
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_more_from_seller
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_price_50_200
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_price_any
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_price_over_200
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_price_unavailable
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_price_under_50
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_report_action
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_report_done
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_report_failed
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_report_reason_offensive
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_report_reason_prohibited
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_report_reason_scam
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_report_reason_spam
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_report_sent
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_report_submit
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_report_title
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_retry
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_search_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_seller
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_share_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sort_high
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sort_low
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sort_newest
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_subtitle
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_hot_deals
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_deal_limited
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_deal_ends_today
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_deal_ends_days
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_deal_claim
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_deal_image_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_deal_open_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_invite_title
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_invite_desc
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_sell_invite_cta
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_shops_title
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_shops_new
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_all_listings
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources.marketplace_title
import kotlin.time.Clock
import kotlin.math.roundToLong
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf

@Composable
fun MarketplaceRoute(
    onItemClick: (String) -> Unit,
    modifier: Modifier = Modifier,
    onRequireSignIn: () -> Unit = {},
    onOpenBusiness: (String) -> Unit = {},
    viewModel: MarketplaceViewModel = koinViewModel(),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    var showSellSheet by remember { mutableStateOf(false) }

    // The shell's global "Post" sheet requested the sell composer (see MarketplaceIntents).
    val pendingSell by MarketplaceIntents.pendingSell.collectAsStateWithLifecycle()
    LaunchedEffect(pendingSell) {
        if (pendingSell) {
            MarketplaceIntents.consume()
            showSellSheet = true
        }
    }

    // Guest tried to publish → close the sheet and route to sign-in.
    LaunchedEffect(state.signInRequired) {
        if (state.signInRequired) {
            showSellSheet = false
            viewModel.consumePublishGate()
            onRequireSignIn()
        }
    }
    // A just-published listing whose photos partly failed to upload — surface a dismissible warning
    // so the seller isn't left with a cover-less listing and no idea why (QA 2026-07-29).
    var photoUploadWarning by remember { mutableStateOf(false) }
    // Published successfully → close the sheet and clear the one-shot flag.
    LaunchedEffect(state.justPublished) {
        if (state.justPublished) {
            showSellSheet = false
            if (state.photoUploadWarning) photoUploadWarning = true
            viewModel.consumePublished()
        }
    }

    Box(modifier = modifier.fillMaxSize()) {
        MarketplaceScreen(
            state = state,
            onCondition = viewModel::setCondition,
            onCategory = viewModel::setCategory,
            onSort = viewModel::setSort,
            onSearch = viewModel::setSearchText,
            onPriceBand = viewModel::setPriceBand,
            onRetry = viewModel::retry,
            onItemClick = onItemClick,
            onSell = { showSellSheet = true },
            onToggleSaved = viewModel::toggleSaved,
            onOpenBusiness = onOpenBusiness,
        )
        if (photoUploadWarning) {
            AppBanner(
                message = stringResource(Res.string.marketplace_photo_upload_warning),
                onDismiss = { photoUploadWarning = false },
                dismissContentDescription = stringResource(Res.string.marketplace_photo_upload_warning_dismiss),
                modifier = Modifier.align(Alignment.TopCenter).statusBarsPadding(),
            )
        }
    }

    if (showSellSheet) {
        val activeCountry by viewModel.activeCountry.collectAsStateWithLifecycle()
        ListingFormSheet(
            sheetTitle = stringResource(Res.string.marketplace_sell),
            submitLabel = stringResource(Res.string.marketplace_sell_publish),
            submitting = state.publishing,
            onDismiss = { showSellSheet = false },
            onSubmit = viewModel::publish,
            country = activeCountry,
            onPickPhoto = viewModel::pickPhoto,
        )
    }
}

/** Responsive Marketplace from Stitch `66b7e10b` (compact) and `3df3f7e4` (expanded). */
@Composable
fun MarketplaceScreen(
    state: MarketplaceUiState,
    onCondition: (ItemCondition?) -> Unit,
    onSort: (MarketplaceSort) -> Unit,
    onRetry: () -> Unit,
    onItemClick: (String) -> Unit,
    onSell: () -> Unit,
    onCategory: (MarketplaceCategory?) -> Unit = {},
    onSearch: (String) -> Unit = {},
    onPriceBand: (MarketplacePriceBand) -> Unit = {},
    onToggleSaved: (String) -> Unit = {},
    /** Hot-deal and shop cards open the merchant's listing. */
    onOpenBusiness: (String) -> Unit = {},
    modifier: Modifier = Modifier,
) {
    if (state.error) {
        ErrorState(
            message = stringResource(Res.string.marketplace_error),
            onRetry = onRetry,
            retryLabel = stringResource(Res.string.marketplace_retry),
            modifier = modifier,
        )
        return
    }
    BoxWithConstraints(modifier = modifier.fillMaxSize().background(AppTheme.colors.background)) {
        val columns = when (windowWidthClassFor(maxWidth)) {
            WindowWidthClass.Compact -> 1
            WindowWidthClass.Medium -> 2
            WindowWidthClass.Expanded -> 4
        }
        LazyColumn(
            modifier = Modifier
                .fillMaxHeight()
                .widthIn(max = AppTheme.sizes.contentMaxWidth)
                .align(Alignment.TopCenter),
            contentPadding = PaddingValues(
                start = AppTheme.spacing.lg,
                end = AppTheme.spacing.lg,
                top = AppTheme.spacing.md,
                bottom = AppTheme.spacing.xl,
            ),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
        ) {
            item {
                Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs)) {
                    Text(
                        text = stringResource(Res.string.marketplace_title),
                        style = AppTheme.typography.headlineLg,
                        color = AppTheme.colors.primary,
                    )
                    Text(
                        text = stringResource(Res.string.marketplace_subtitle),
                        style = AppTheme.typography.bodyMd,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                }
            }
            // Stitch 66b7e10b: the category strip leads the page, above everything else.
            item(key = "categories") {
                CategoryChips(category = state.category, onCategory = onCategory)
            }
            // Hot Deals — live merchant promotions: one hero, then compact rows.
            if (state.deals.isNotEmpty()) {
                item(key = "hot_deals_header") {
                    SectionHeader(title = stringResource(Res.string.marketplace_hot_deals))
                }
                val hero = state.deals.first()
                item(key = "deal_hero_" + hero.id) {
                    HotDealHero(
                        deal = hero,
                        business = state.dealBusinesses[hero.businessId],
                        lang = AppTheme.language,
                        onClick = { onOpenBusiness(hero.businessId) },
                    )
                }
                items(state.deals.drop(1), key = { "deal_" + it.id }) { deal ->
                    HotDealRow(
                        deal = deal,
                        business = state.dealBusinesses[deal.businessId],
                        lang = AppTheme.language,
                        onClick = { onOpenBusiness(deal.businessId) },
                    )
                }
            }
            // Brand invitation card (the Stitch "draw" slot). Sellers who already list don't need the pitch.
            if (state.myItems.isEmpty()) {
                item(key = "sell_invite") { SellInviteCard(onSell = onSell) }
            }
            if (state.myItems.isNotEmpty()) {
                item {
                    Text(
                        text = stringResource(Res.string.marketplace_my_listings),
                        style = AppTheme.typography.labelMd,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                }
                items(state.myItems.chunked(columns), key = { row -> "mine_" + row.first().id }) { row ->
                    Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg)) {
                        row.forEach { mine ->
                            Box(modifier = Modifier.weight(1f)) {
                                MarketplaceItem(
                                    item = mine,
                                    onClick = { onItemClick(mine.id) },
                                    soldLabel = if (mine.status == ItemStatus.Sold) {
                                        stringResource(Res.string.marketplace_status_sold)
                                    } else null,
                                )
                            }
                        }
                        repeat(columns - row.size) { Spacer(modifier = Modifier.weight(1f)) }
                    }
                }
            }
            if (state.savedItems.isNotEmpty()) {
                item {
                    Text(
                        text = stringResource(Res.string.marketplace_saved),
                        style = AppTheme.typography.labelMd,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                }
                // Horizontal rail — saved items shouldn't push the browse grid below the fold.
                item {
                    LazyRow(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                        items(state.savedItems, key = { "saved_" + it.id }) { saved ->
                            MarketplaceRailItem(
                                item = saved,
                                onClick = { onItemClick(saved.id) },
                                soldLabel = if (saved.status == ItemStatus.Sold) {
                                    stringResource(Res.string.marketplace_status_sold)
                                } else null,
                                saved = true,
                                onToggleSaved = { onToggleSaved(saved.id) },
                            )
                        }
                    }
                }
            }
            // Paid placements (admin-set `featured`, mirroring business sponsorships).
            run {
                val featuredItems = state.items.filter { it.featured && it.status == ItemStatus.Active }
                if (featuredItems.isNotEmpty()) {
                    item {
                        Text(
                            text = stringResource(Res.string.marketplace_featured_section),
                            style = AppTheme.typography.labelMd,
                            color = AppTheme.colors.onSurfaceVariant,
                        )
                    }
                    item {
                        LazyRow(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                            items(featuredItems, key = { "feat_" + it.id }) { item ->
                                MarketplaceRailItem(
                                    item = item,
                                    onClick = { onItemClick(item.id) },
                                    saved = item.id in state.savedIds,
                                    onToggleSaved = { onToggleSaved(item.id) },
                                )
                            }
                        }
                    }
                }
            }
            // An empty peer market still has real shops to browse — put them above the empty state.
            if (!state.loading && state.items.isEmpty() && state.shops.isNotEmpty()) {
                shopsRail(state.shops, onOpenBusiness)
            }
            item(key = "all_listings_header") {
                SectionHeader(title = stringResource(Res.string.marketplace_all_listings))
            }
            item {
                MarketplaceFilters(
                    condition = state.condition,
                    sort = state.sort,
                    searchText = state.searchText,
                    priceBand = state.priceBand,
                    onCondition = onCondition,
                    onSort = onSort,
                    onSearch = onSearch,
                    onPriceBand = onPriceBand,
                )
            }
            if (state.loading) {
                // Shimmer 2-up grid mirroring the listing cards.
                items(2) {
                    Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                        repeat(2) {
                            Box(modifier = Modifier.weight(1f)) {
                                MediaCardSkeleton(coverAspectRatio = 4f / 3f)
                            }
                        }
                    }
                }
            } else if (state.items.isEmpty()) {
                item {
                    // Empty market = invitation to seed it, not a dead end.
                    EmptyState(
                        title = stringResource(Res.string.marketplace_empty_title),
                        description = stringResource(Res.string.marketplace_empty_description),
                        actionLabel = stringResource(Res.string.marketplace_sell_cta),
                        onAction = onSell,
                    )
                }
            } else {
                items(state.items.chunked(columns), key = { row -> row.first().id }) { row ->
                    Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg)) {
                        row.forEach { item ->
                            Box(modifier = Modifier.weight(1f)) {
                                MarketplaceItem(
                                    item = item,
                                    onClick = { onItemClick(item.id) },
                                    saved = item.id in state.savedIds,
                                    onToggleSaved = { onToggleSaved(item.id) },
                                )
                            }
                        }
                        repeat(columns - row.size) { Spacer(modifier = Modifier.weight(1f)) }
                    }
                }
                if (state.shops.isNotEmpty()) shopsRail(state.shops, onOpenBusiness)
            }
        }

        // No in-tab sell FAB: the shell's global "Post" button owns creation (it opens the sell
        // sheet here via MarketplaceIntents) — two stacked FABs collided bottom-end.
    }
}

@Composable
private fun MarketplaceFilters(
    condition: ItemCondition?,
    sort: MarketplaceSort,
    searchText: String,
    priceBand: MarketplacePriceBand,
    onCondition: (ItemCondition?) -> Unit,
    onSort: (MarketplaceSort) -> Unit,
    onSearch: (String) -> Unit,
    onPriceBand: (MarketplacePriceBand) -> Unit,
) {
    // Category is the page-level strip (see CategoryChips); here: search, then condition/sort/price.
    Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
        AppTextField(
            value = searchText,
            onValueChange = onSearch,
            placeholder = stringResource(Res.string.marketplace_search_placeholder),
            singleLine = true,
            leading = {
                AppIcon(
                    name = "search",
                    size = AppTheme.sizes.iconMd,
                    tint = AppTheme.colors.onSurfaceVariant,
                )
            },
        )
        Row(
            modifier = Modifier.horizontalScroll(rememberScrollState()),
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            AppChip(
                label = stringResource(Res.string.marketplace_all),
                selected = condition == null,
                onClick = { onCondition(null) },
            )
            ItemCondition.entries.forEach { value ->
                AppChip(
                    label = conditionLabel(value),
                    selected = condition == value,
                    onClick = { onCondition(value) },
                )
            }
            MarketplaceSort.entries.forEach { value ->
                AppChip(
                    label = sortLabel(value),
                    selected = sort == value,
                    leadingIcon = if (value == MarketplaceSort.Newest) "schedule" else "payments",
                    onClick = { onSort(value) },
                )
            }
        }
        Row(
            modifier = Modifier.horizontalScroll(rememberScrollState()),
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            MarketplacePriceBand.entries.forEach { value ->
                AppChip(
                    label = priceBandLabel(value),
                    selected = priceBand == value,
                    onClick = { onPriceBand(value) },
                )
            }
        }
    }
}

/** Page-level category strip (Stitch 66b7e10b) — the primary browse axis buyers scan first. */
@Composable
private fun CategoryChips(category: MarketplaceCategory?, onCategory: (MarketplaceCategory?) -> Unit) {
    Row(
        modifier = Modifier.horizontalScroll(rememberScrollState()),
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
    ) {
        AppChip(
            label = stringResource(Res.string.marketplace_cat_all),
            selected = category == null,
            onClick = { onCategory(null) },
        )
        MarketplaceCategory.entries.forEach { value ->
            AppChip(
                label = categoryLabel(value),
                selected = category == value,
                onClick = { onCategory(value) },
            )
        }
    }
}

/** "Ends today" / "Ends in N days" for a deal's expiry. */
@Composable
private fun dealEndsLabel(deal: Deal, lang: Language): String {
    val remaining = deal.endsAtMillis - Clock.System.now().toEpochMilliseconds()
    val days = (remaining + DAY_MILLIS - 1) / DAY_MILLIS
    return if (days <= 1) stringResource(Res.string.marketplace_deal_ends_today)
    else stringResource(Res.string.marketplace_deal_ends_days, lang.formatCount(days))
}

/**
 * Hot Deals hero (Stitch 66b7e10b): the merchant's cover under a bottom scrim, the merchant as a
 * gold pill top-start, urgency badge + headline + fine print + "Claim offer" over the image.
 */
@Composable
private fun HotDealHero(
    deal: Deal,
    business: Business?,
    lang: Language,
    onClick: () -> Unit,
) {
    AppCard(modifier = Modifier.fillMaxWidth(), onClick = onClick, elevation = AppTheme.elevation.level2) {
        Box(modifier = Modifier.fillMaxWidth().aspectRatio(HERO_ASPECT)) {
            BusinessCover(
                imageUrl = business?.coverUrl ?: business?.photos?.firstOrNull(),
                contentDescription = stringResource(Res.string.marketplace_deal_image_a11y, deal.businessName),
                iconName = "sell",
            )
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Brush.verticalGradient(listOf(Color.Transparent, AppTheme.colors.scrim))),
            )
            IconBadge(
                label = deal.businessName,
                iconName = if (business?.verified == true) "verified" else "storefront",
                containerColor = AppTheme.colors.secondaryContainer,
                contentColor = AppTheme.colors.onSecondaryContainer,
                modifier = Modifier.align(Alignment.TopEnd).padding(AppTheme.spacing.md),
            )
            Column(
                modifier = Modifier
                    .align(Alignment.BottomStart)
                    .fillMaxWidth()
                    .padding(AppTheme.spacing.lg),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            ) {
                IconBadge(
                    label = dealEndsLabel(deal, lang),
                    iconName = "schedule",
                    containerColor = AppTheme.colors.error,
                    contentColor = AppTheme.colors.onError,
                )
                Text(
                    text = deal.title.resolve(lang),
                    style = AppTheme.typography.headlineMd,
                    color = AppTheme.colors.onScrim,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                )
                deal.details?.resolve(lang)?.takeIf { it.isNotBlank() }?.let { details ->
                    Text(
                        text = details,
                        style = AppTheme.typography.bodyMd,
                        color = AppTheme.colors.onScrim,
                        maxLines = 2,
                        overflow = TextOverflow.Ellipsis,
                    )
                }
                AppButton(
                    text = stringResource(Res.string.marketplace_deal_claim),
                    onClick = onClick,
                    trailingIcon = "arrow_forward",
                )
            }
        }
    }
}

/** Compact Hot Deals row (Stitch "Limited time" card): urgency kicker, headline, merchant, thumbnail. */
@Composable
private fun HotDealRow(
    deal: Deal,
    business: Business?,
    lang: Language,
    onClick: () -> Unit,
) {
    AppCard(modifier = Modifier.fillMaxWidth(), onClick = onClick) {
        Row(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Column(
                modifier = Modifier.weight(1f),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
            ) {
                Text(
                    text = stringResource(Res.string.marketplace_deal_limited),
                    style = AppTheme.typography.labelSm,
                    color = AppTheme.colors.error,
                )
                Text(
                    text = deal.title.resolve(lang),
                    style = AppTheme.typography.titleSm,
                    color = AppTheme.colors.onSurface,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                )
                Text(
                    text = deal.businessName,
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
                Text(
                    text = dealEndsLabel(deal, lang),
                    style = AppTheme.typography.labelSm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
            Box(
                modifier = Modifier
                    .size(AppTheme.sizes.listThumbnail)
                    .clip(AppTheme.shapes.md),
            ) {
                BusinessCover(
                    imageUrl = business?.logoUrl ?: business?.coverUrl,
                    contentDescription = stringResource(Res.string.marketplace_deal_image_a11y, deal.businessName),
                    iconName = "sell",
                )
            }
            AppIcon(
                name = "chevron_right",
                size = AppTheme.sizes.iconMd,
                tint = AppTheme.colors.primary,
                contentDescription = stringResource(Res.string.marketplace_deal_open_a11y),
            )
        }
    }
}

/** Teal invitation card (the Stitch promo slot): sell to the neighbourhood, free. */
@Composable
private fun SellInviteCard(onSell: () -> Unit) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(AppTheme.shapes.card)
            .background(AppTheme.colors.primary)
            .padding(AppTheme.spacing.xl),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
    ) {
        AppIcon(name = "storefront", size = AppTheme.sizes.iconLg, tint = AppTheme.colors.brandGold)
        Text(
            text = stringResource(Res.string.marketplace_sell_invite_title),
            style = AppTheme.typography.headlineMd,
            color = AppTheme.colors.onPrimary,
            textAlign = TextAlign.Center,
        )
        Text(
            text = stringResource(Res.string.marketplace_sell_invite_desc),
            style = AppTheme.typography.bodyMd,
            color = AppTheme.colors.onPrimary,
            textAlign = TextAlign.Center,
        )
        AppButton(
            text = stringResource(Res.string.marketplace_sell_invite_cta),
            onClick = onSell,
            variant = AppButtonVariant.Tonal,
            leadingIcon = "add",
        )
    }
}

/** "Shops in your mahaleh" — retail/grocery listings of the active metro as a Featured-style rail. */
private fun LazyListScope.shopsRail(shops: List<Business>, onOpenBusiness: (String) -> Unit) {
    item(key = "shops_header") {
        SectionHeader(title = stringResource(Res.string.marketplace_shops_title))
    }
    item(key = "shops_rail") {
        val lang = AppTheme.language
        LazyRow(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
            items(shops, key = { "shop_" + it.id }) { shop ->
                val name = shop.nameLocalized?.resolve(lang)?.takeIf { it.isNotBlank() } ?: shop.name
                FeaturedBusinessCard(
                    name = name,
                    subtitle = shop.serviceTitle?.resolve(lang)?.takeIf { it.isNotBlank() }
                        ?: shop.description.resolve(lang),
                    rating = shop.rating.toFloat(),
                    city = AppTheme.language.cityLabel(shop.address.city),
                    newLabel = if (shop.reviewCount == 0) stringResource(Res.string.marketplace_shops_new) else null,
                    onClick = { onOpenBusiness(shop.id) },
                    image = {
                        BusinessCover(
                            imageUrl = shop.coverUrl ?: shop.photos.firstOrNull(),
                            contentDescription = stringResource(Res.string.marketplace_image_a11y, name),
                        )
                    },
                )
            }
        }
    }
}

/** Hot Deals hero image ratio (Stitch 66b7e10b: a tall 4:5 poster). */
private const val HERO_ASPECT = 4f / 5f
private const val DAY_MILLIS = 24L * 60 * 60 * 1_000

@Composable
private fun priceBandLabel(band: MarketplacePriceBand): String = stringResource(
    when (band) {
        MarketplacePriceBand.Any -> Res.string.marketplace_price_any
        MarketplacePriceBand.Free -> Res.string.marketplace_free
        MarketplacePriceBand.Under50 -> Res.string.marketplace_price_under_50
        MarketplacePriceBand.From50To200 -> Res.string.marketplace_price_50_200
        MarketplacePriceBand.Over200 -> Res.string.marketplace_price_over_200
    },
)

@Composable
private fun MarketplaceItem(
    item: MarketplaceItem,
    onClick: () -> Unit,
    soldLabel: String? = null,
    saved: Boolean = false,
    onToggleSaved: (() -> Unit)? = null,
) {
    MarketplaceItemCard(
        title = item.title,
        sellerName = item.sellerName,
        price = item.priceLabel(),
        condition = conditionLabel(item.condition),
        imageContentDescription = stringResource(Res.string.marketplace_image_a11y, item.title),
        imageUrl = item.photoUrls.firstOrNull(),
        // A sold badge wins over the "Free" tag on the seller's own listings.
        badgeLabel = soldLabel ?: if (item.isFree) stringResource(Res.string.marketplace_free) else null,
        metaLabel = item.metaLabel(),
        onClick = onClick,
        favorite = saved,
        favoriteContentDescription = stringResource(
            if (saved) Res.string.marketplace_saved_a11y else Res.string.marketplace_save_a11y,
        ),
        onToggleFavorite = onToggleSaved,
        modifier = Modifier.fillMaxWidth(),
    )
}

/**
 * Compact rail entry — [MarketItemRailCard] with this screen's price/condition formatting. The
 * price pill already reads "Free" for free items, so [soldLabel] is the only badge case.
 */
@Composable
private fun MarketplaceRailItem(
    item: MarketplaceItem,
    onClick: () -> Unit,
    soldLabel: String? = null,
    saved: Boolean = false,
    onToggleSaved: (() -> Unit)? = null,
) {
    MarketItemRailCard(
        title = item.title,
        price = item.priceLabel(),
        condition = conditionLabel(item.condition),
        imageContentDescription = stringResource(Res.string.marketplace_image_a11y, item.title),
        onClick = onClick,
        imageUrl = item.photoUrls.firstOrNull(),
        badgeLabel = soldLabel,
        favorite = saved,
        favoriteContentDescription = stringResource(
            if (saved) Res.string.marketplace_saved_a11y else Res.string.marketplace_save_a11y,
        ),
        onToggleFavorite = onToggleSaved,
        modifier = Modifier.width(AppTheme.sizes.railItemCardWidth),
    )
}

@Composable
fun MarketplaceItemDetailRoute(
    itemId: String,
    onBack: () -> Unit,
    modifier: Modifier = Modifier,
    onRequireSignIn: () -> Unit = {},
    onOpenConversation: (String) -> Unit = {},
    onOpenItem: (String) -> Unit = {},
    viewModel: MarketplaceItemDetailViewModel = koinViewModel(parameters = { parametersOf(itemId) }),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    var showReportSheet by remember { mutableStateOf(false) }
    var showEditSheet by remember { mutableStateOf(false) }

    // Same share plumbing as business detail: platform ShareService + Remote-Config-driven base URL.
    val shareService = koinInject<ShareService>()
    val shareConfig = koinInject<ShareConfig>()
    val shareMessage = state.item?.let { item ->
        listOf(item.title, item.priceLabel(), shareConfig.itemLink(item.id)).joinToString("\n")
    }

    LaunchedEffect(state.reportStatus) {
        if (state.reportStatus == ItemReportStatus.SignInRequired) {
            showReportSheet = false
            viewModel.resetReport()
            onRequireSignIn()
        }
    }
    LaunchedEffect(state.editSaved) {
        if (state.editSaved) {
            showEditSheet = false
            viewModel.consumeEditSaved()
        }
    }
    // Listing deleted → leave the (now-gone) detail screen.
    LaunchedEffect(state.deleted) {
        if (state.deleted) onBack()
    }
    LaunchedEffect(state.openConversationId, state.messageSellerSignInRequired) {
        val conversationId = state.openConversationId
        when {
            conversationId != null -> {
                viewModel.consumeConversation()
                onOpenConversation(conversationId)
            }
            state.messageSellerSignInRequired -> {
                viewModel.consumeConversation()
                onRequireSignIn()
            }
        }
    }

    MarketplaceItemDetailScreen(
        state = state,
        onBack = onBack,
        onRetry = viewModel::retry,
        onReport = { showReportSheet = true },
        onShare = { shareMessage?.let(shareService::share) },
        onMarkSold = viewModel::markSold,
        onEdit = { showEditSheet = true },
        onToggleSaved = viewModel::toggleSave,
        onAddPhoto = viewModel::addPhoto,
        onDelete = viewModel::delete,
        onMessageSeller = viewModel::messageSeller,
        onOpenItem = onOpenItem,
        modifier = modifier,
    )

    val editItem = state.item
    if (showEditSheet && editItem != null) {
        ListingFormSheet(
            sheetTitle = stringResource(Res.string.marketplace_edit),
            submitLabel = stringResource(Res.string.marketplace_edit_save),
            submitting = state.savingEdit,
            onDismiss = { showEditSheet = false },
            // Edit doesn't change photos (managed on the detail screen) — drop the photos arg.
            onSubmit = { t, d, p, f, c, cat, city, _ -> viewModel.updateListing(t, d, p, f, c, cat, city) },
            initialTitle = editItem.title,
            initialDescription = editItem.description,
            initialPriceText = centsToDollarsText(editItem.priceCents),
            initialFree = editItem.isFree,
            initialCondition = editItem.condition,
            initialCategory = editItem.category,
            initialCity = editItem.city,
            country = Metros.byId(editItem.metroId)?.country,
        )
    }

    if (showReportSheet) {
        ReportSheet(
            title = stringResource(Res.string.marketplace_report_title),
            reasons = listOf(
                ReportReason(stringResource(Res.string.marketplace_report_reason_prohibited), "prohibited_item"),
                ReportReason(stringResource(Res.string.marketplace_report_reason_offensive), "offensive_content"),
                ReportReason(stringResource(Res.string.marketplace_report_reason_scam), "scam_or_fraud"),
                ReportReason(stringResource(Res.string.marketplace_report_reason_spam), "spam"),
            ),
            status = when (state.reportStatus) {
                ItemReportStatus.Sending -> ReportStatus.Sending
                ItemReportStatus.Sent -> ReportStatus.Sent
                ItemReportStatus.Failed -> ReportStatus.Failed
                ItemReportStatus.Idle, ItemReportStatus.SignInRequired -> ReportStatus.Idle
            },
            sentText = stringResource(Res.string.marketplace_report_sent),
            failedText = stringResource(Res.string.marketplace_report_failed),
            submitText = stringResource(Res.string.marketplace_report_submit),
            doneText = stringResource(Res.string.marketplace_report_done),
            onSubmit = viewModel::report,
            onDismiss = {
                showReportSheet = false
                viewModel.resetReport()
            },
        )
    }
}

/** Item detail from Stitch `4f6fb597`; seller messaging stays visibly disabled until direct chat lands. */
@Composable
fun MarketplaceItemDetailScreen(
    state: MarketplaceItemDetailUiState,
    onBack: () -> Unit,
    onRetry: () -> Unit,
    onReport: () -> Unit,
    onMarkSold: () -> Unit,
    onEdit: () -> Unit,
    onShare: () -> Unit = {},
    onToggleSaved: () -> Unit = {},
    onAddPhoto: () -> Unit = {},
    onDelete: () -> Unit = {},
    onMessageSeller: () -> Unit = {},
    onOpenItem: (String) -> Unit = {},
    modifier: Modifier = Modifier,
) {
    if (state.error) {
        ErrorState(
            message = stringResource(Res.string.marketplace_error),
            onRetry = onRetry,
            retryLabel = stringResource(Res.string.marketplace_retry),
            modifier = modifier,
        )
        return
    }
    if (state.loading || state.item == null) {
        // Detail skeleton: cover + title/price lines where the real content will land.
        Column(modifier = modifier.padding(AppTheme.spacing.lg)) {
            MediaCardSkeleton()
        }
        return
    }
    val item = state.item
    var selectedPhoto by remember(item.id) { mutableIntStateOf(0) }
    LazyColumn(
        // Pushed route (no scaffold bottom bar) — without the inset the system navigation
        // overlaps the last items when scrolled to the bottom (owner device report 2026-07-24).
        modifier = modifier.fillMaxSize().background(AppTheme.colors.background).navigationBarsPadding(),
        contentPadding = PaddingValues(bottom = AppTheme.spacing.xl),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
    ) {
        item {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(AppTheme.colors.surface)
                    .statusBarsPadding()
                    .padding(horizontal = AppTheme.spacing.sm, vertical = AppTheme.spacing.xs),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                AppIconButton(
                    iconName = "arrow_back",
                    contentDescription = stringResource(Res.string.marketplace_back_a11y),
                    onClick = onBack,
                )
                Text(
                    text = stringResource(Res.string.marketplace_title),
                    style = AppTheme.typography.headlineMd,
                    color = AppTheme.colors.onSurface,
                    modifier = Modifier.weight(1f),
                )
                AppIconButton(
                    iconName = "share",
                    contentDescription = stringResource(Res.string.marketplace_share_a11y),
                    onClick = onShare,
                )
                AppIconButton(
                    iconName = if (state.isSaved) "favorite" else "favorite_border",
                    filled = state.isSaved,
                    contentDescription = stringResource(
                        if (state.isSaved) Res.string.marketplace_saved_a11y else Res.string.marketplace_save_a11y,
                    ),
                    onClick = onToggleSaved,
                )
                AppIconButton(
                    iconName = "flag",
                    contentDescription = stringResource(Res.string.marketplace_report_action),
                    onClick = onReport,
                )
            }
        }
        item {
            Column(
                modifier = Modifier
                    .widthIn(max = AppTheme.sizes.contentMaxWidthCompact)
                    .fillMaxWidth()
                    .padding(horizontal = AppTheme.spacing.lg),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                BusinessCover(
                    imageUrl = item.photoUrls.getOrNull(selectedPhoto),
                    contentDescription = stringResource(Res.string.marketplace_image_a11y, item.title),
                    iconName = "shopping_bag",
                    modifier = Modifier
                        .fillMaxWidth()
                        .aspectRatio(4f / 3f),
                )
                if (item.photoUrls.size > 1) {
                    Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                        item.photoUrls.take(4).forEachIndexed { index, url ->
                            BusinessCover(
                                imageUrl = url,
                                contentDescription = stringResource(Res.string.marketplace_image_a11y, item.title),
                                iconName = "shopping_bag",
                                modifier = Modifier
                                    .weight(1f)
                                    .aspectRatio(1f)
                                    .clickable { selectedPhoto = index },
                            )
                        }
                    }
                }
            }
        }
        item {
            Column(
                modifier = Modifier
                    .widthIn(max = AppTheme.sizes.contentMaxWidthCompact)
                    .fillMaxWidth()
                    .padding(horizontal = AppTheme.spacing.lg),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                StatusBadge(label = conditionLabel(item.condition))
                Text(
                    text = item.title,
                    style = AppTheme.typography.headlineLg,
                    color = AppTheme.colors.onSurface,
                )
                Text(
                    text = item.priceLabel(),
                    style = AppTheme.typography.headlineLg,
                    color = AppTheme.colors.primary,
                )
                if (item.city.isNotBlank()) {
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        AppIcon(
                            name = "location_on",
                            size = AppTheme.sizes.iconSm,
                            tint = AppTheme.colors.primary,
                        )
                        Text(
                            text = stringResource(Res.string.marketplace_location, AppTheme.language.cityLabel(item.city)),
                            style = AppTheme.typography.bodyMd,
                            color = AppTheme.colors.onSurfaceVariant,
                        )
                    }
                }
                Text(
                    text = stringResource(Res.string.marketplace_item_description),
                    style = AppTheme.typography.labelMd,
                    color = AppTheme.colors.primary,
                )
                Text(
                    text = item.description,
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurfaceVariant,
                )
                SellerCard(
                    item = item,
                    isSeller = state.isSeller,
                    markingSold = state.markingSold,
                    markSoldFailed = state.markSoldFailed,
                    editFailed = state.editFailed,
                    addingPhoto = state.addingPhoto,
                    photoFailed = state.photoFailed,
                    deleting = state.deleting,
                    deleteFailed = state.deleteFailed,
                    openingConversation = state.openingConversation,
                    messageSellerFailed = state.messageSellerFailed,
                    onMarkSold = onMarkSold,
                    onEdit = onEdit,
                    onAddPhoto = onAddPhoto,
                    onDelete = onDelete,
                    onMessageSeller = onMessageSeller,
                )
            }
        }
        if (state.sellerItems.isNotEmpty()) {
            item {
                Column(
                    modifier = Modifier
                        .widthIn(max = AppTheme.sizes.contentMaxWidthCompact)
                        .fillMaxWidth()
                        .padding(horizontal = AppTheme.spacing.lg),
                    verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                ) {
                    SectionHeader(title = stringResource(Res.string.marketplace_more_from_seller))
                    LazyRow(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                        items(state.sellerItems, key = { it.id }) { sellerItem ->
                            MarketplaceRailItem(
                                item = sellerItem,
                                onClick = { onOpenItem(sellerItem.id) },
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun SellerCard(
    item: MarketplaceItem,
    isSeller: Boolean,
    markingSold: Boolean,
    markSoldFailed: Boolean,
    editFailed: Boolean,
    addingPhoto: Boolean,
    photoFailed: Boolean,
    deleting: Boolean,
    deleteFailed: Boolean,
    openingConversation: Boolean,
    messageSellerFailed: Boolean,
    onMarkSold: () -> Unit,
    onEdit: () -> Unit,
    onAddPhoto: () -> Unit,
    onDelete: () -> Unit,
    onMessageSeller: () -> Unit,
) {
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            Text(
                text = stringResource(Res.string.marketplace_seller),
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
            Row(
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                PersonAvatar(
                    id = item.sellerUid,
                    name = item.sellerName,
                    size = AppTheme.sizes.avatarMd,
                )
                Text(
                    text = item.sellerName,
                    style = AppTheme.typography.headlineMd,
                    color = AppTheme.colors.onSurface,
                )
            }
            when {
                // Seller-only controls: mark the listing sold, or show it's already sold.
                isSeller && item.status == ItemStatus.Sold -> {
                    StatusBadge(label = stringResource(Res.string.marketplace_status_sold))
                    Text(
                        text = stringResource(Res.string.marketplace_sold_note),
                        style = AppTheme.typography.bodySm,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                }
                isSeller -> {
                    AppButton(
                        text = stringResource(Res.string.marketplace_add_photo),
                        onClick = onAddPhoto,
                        variant = AppButtonVariant.Secondary,
                        leadingIcon = "add_a_photo",
                        enabled = !addingPhoto && !markingSold,
                        loading = addingPhoto,
                        modifier = Modifier.fillMaxWidth(),
                    )
                    AppButton(
                        text = stringResource(Res.string.marketplace_edit_action),
                        onClick = onEdit,
                        variant = AppButtonVariant.Secondary,
                        leadingIcon = "edit",
                        enabled = !markingSold && !addingPhoto,
                        modifier = Modifier.fillMaxWidth(),
                    )
                    // Confirmed, because it's one tap and there is no un-sold path in the UI —
                    // a graze here permanently retires the listing.
                    var confirmMarkSold by remember { mutableStateOf(false) }
                    AppButton(
                        text = stringResource(Res.string.marketplace_mark_sold),
                        onClick = { confirmMarkSold = true },
                        leadingIcon = "check_circle",
                        enabled = !markingSold && !addingPhoto,
                        loading = markingSold,
                        modifier = Modifier.fillMaxWidth(),
                    )
                    if (confirmMarkSold) {
                        AppConfirmDialog(
                            title = stringResource(Res.string.marketplace_mark_sold),
                            message = stringResource(Res.string.marketplace_mark_sold_confirm),
                            confirmLabel = stringResource(Res.string.marketplace_mark_sold),
                            cancelLabel = stringResource(Res.string.marketplace_mark_sold_cancel),
                            onConfirm = {
                                confirmMarkSold = false
                                onMarkSold()
                            },
                            onDismiss = { confirmMarkSold = false },
                        )
                    }
                    if (markSoldFailed) {
                        Text(
                            text = stringResource(Res.string.marketplace_mark_sold_failed),
                            style = AppTheme.typography.bodySm,
                            color = AppTheme.colors.error,
                        )
                    }
                    if (editFailed) {
                        Text(
                            text = stringResource(Res.string.marketplace_edit_failed),
                            style = AppTheme.typography.bodySm,
                            color = AppTheme.colors.error,
                        )
                    }
                    if (photoFailed) {
                        Text(
                            text = stringResource(Res.string.marketplace_add_photo_failed),
                            style = AppTheme.typography.bodySm,
                            color = AppTheme.colors.error,
                        )
                    }
                }
                else -> {
                    AppButton(
                        text = stringResource(Res.string.marketplace_message_seller),
                        onClick = onMessageSeller,
                        leadingIcon = "chat",
                        enabled = !openingConversation,
                        loading = openingConversation,
                        modifier = Modifier.fillMaxWidth(),
                    )
                    if (messageSellerFailed) {
                        Text(
                            text = stringResource(Res.string.marketplace_message_seller_failed),
                            style = AppTheme.typography.bodySm,
                            color = AppTheme.colors.error,
                        )
                    }
                }
            }
            // Delete — available to the seller in any state (active or sold). Permanent, so guarded.
            if (isSeller) {
                var confirmDelete by remember { mutableStateOf(false) }
                AppButton(
                    text = stringResource(Res.string.marketplace_delete_action),
                    onClick = { confirmDelete = true },
                    variant = AppButtonVariant.Text,
                    leadingIcon = "delete",
                    enabled = !deleting && !markingSold && !addingPhoto,
                    loading = deleting,
                    modifier = Modifier.fillMaxWidth(),
                )
                if (confirmDelete) {
                    AppConfirmDialog(
                        title = stringResource(Res.string.marketplace_delete_action),
                        message = stringResource(Res.string.marketplace_delete_confirm),
                        confirmLabel = stringResource(Res.string.marketplace_delete_action),
                        cancelLabel = stringResource(Res.string.marketplace_mark_sold_cancel),
                        destructive = true,
                        onConfirm = { confirmDelete = false; onDelete() },
                        onDismiss = { confirmDelete = false },
                    )
                }
                if (deleteFailed) {
                    Text(
                        text = stringResource(Res.string.marketplace_delete_failed),
                        style = AppTheme.typography.bodySm,
                        color = AppTheme.colors.error,
                    )
                }
            }
        }
    }
}

@Composable
private fun conditionLabel(condition: ItemCondition): String = stringResource(
    when (condition) {
        ItemCondition.New -> Res.string.marketplace_condition_new
        ItemCondition.LikeNew -> Res.string.marketplace_condition_like_new
        ItemCondition.Used -> Res.string.marketplace_condition_used
    },
)

@Composable
private fun categoryLabel(category: MarketplaceCategory): String = stringResource(
    when (category) {
        MarketplaceCategory.Furniture -> Res.string.marketplace_cat_furniture
        MarketplaceCategory.Electronics -> Res.string.marketplace_cat_electronics
        MarketplaceCategory.HomeKitchen -> Res.string.marketplace_cat_home_kitchen
        MarketplaceCategory.Appliances -> Res.string.marketplace_cat_appliances
        MarketplaceCategory.Clothing -> Res.string.marketplace_cat_clothing
        MarketplaceCategory.Kids -> Res.string.marketplace_cat_kids
        MarketplaceCategory.Books -> Res.string.marketplace_cat_books
        MarketplaceCategory.Vehicles -> Res.string.marketplace_cat_vehicles
        MarketplaceCategory.Sports -> Res.string.marketplace_cat_sports
        MarketplaceCategory.Other -> Res.string.marketplace_cat_other
    },
)

@Composable
private fun sortLabel(sort: MarketplaceSort): String = stringResource(
    when (sort) {
        MarketplaceSort.Newest -> Res.string.marketplace_sort_newest
        MarketplaceSort.PriceLow -> Res.string.marketplace_sort_low
        MarketplaceSort.PriceHigh -> Res.string.marketplace_sort_high
    },
)

@Composable
private fun MarketplaceItem.priceLabel(): String {
    if (isFree) return stringResource(Res.string.marketplace_free)
    val cents = priceCents ?: return stringResource(Res.string.marketplace_price_unavailable)
    return AppTheme.language.formatPriceCents(cents)
}

/** "City · 2h ago" line for a listing card — the two fields buyers scan first. Either half may be absent. */
@Composable
private fun MarketplaceItem.metaLabel(): String? {
    val time = createdAtMillis?.let { relativeItemTime(it) }
    return listOfNotNull(city.takeIf { it.isNotBlank() }, time).joinToString(" · ").takeIf { it.isNotEmpty() }
}

/** Relative "posted N ago" label bucketed to the largest sensible unit (localized digits). */
@Composable
private fun relativeItemTime(millis: Long): String {
    val minutes = ((Clock.System.now().toEpochMilliseconds() - millis) / 60_000L).coerceAtLeast(0)
    val lang = AppTheme.language
    return when {
        minutes < 1 -> stringResource(Res.string.marketplace_time_just_now)
        minutes < 60 -> stringResource(Res.string.marketplace_time_minutes_ago, lang.formatCount(minutes))
        minutes < 60 * 24 -> stringResource(Res.string.marketplace_time_hours_ago, lang.formatCount(minutes / 60))
        minutes < 60 * 24 * 7 -> stringResource(Res.string.marketplace_time_days_ago, lang.formatCount(minutes / (60 * 24)))
        else -> stringResource(Res.string.marketplace_time_weeks_ago, lang.formatCount(minutes / (60 * 24 * 7)))
    }
}

private val previewItems = listOf(
    MarketplaceItem(
        id = "preview-kilim",
        sellerUid = "seller",
        sellerName = "Amir",
        title = "Handmade Persian Kilim",
        description = "Hand-woven wool kilim.",
        priceCents = 42000,
        condition = ItemCondition.New,
        city = "North Vancouver",
    ),
    MarketplaceItem(
        id = "preview-samovar",
        sellerUid = "seller-2",
        sellerName = "Sara",
        title = "Vintage Samovar",
        description = "Restored and ready to use.",
        isFree = true,
        condition = ItemCondition.LikeNew,
        city = "Toronto",
    ),
)

@Preview(name = "Marketplace compact", widthDp = 390, heightDp = 844)
@Composable
private fun MarketplaceCompactPreview() {
    AppTheme {
        MarketplaceScreen(
            state = MarketplaceUiState(loading = false, items = previewItems),
            onCondition = {},
            onSort = {},
            onRetry = {},
            onItemClick = {},
            onSell = {},
        )
    }
}

@Preview(name = "Marketplace expanded", widthDp = 1200, heightDp = 900)
@Composable
private fun MarketplaceExpandedPreview() {
    AppTheme {
        MarketplaceScreen(
            state = MarketplaceUiState(loading = false, items = previewItems),
            onCondition = {},
            onSort = {},
            onRetry = {},
            onItemClick = {},
            onSell = {},
        )
    }
}

/**
 * Reusable listing form bottom sheet, used for both **create** (empty initial values) and **edit**
 * (the item's current values). Photos are deferred (Storage upload = Phase 2, same as Add Business),
 * so the form carries title/description/price-or-free/condition/city. On create the active metro is
 * attached by the ViewModel; submitting is sign-in-gated (the route routes guests out).
 */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun ListingFormSheet(
    sheetTitle: String,
    submitLabel: String,
    submitting: Boolean,
    onDismiss: () -> Unit,
    onSubmit: (
        title: String,
        description: String,
        priceCents: Long?,
        isFree: Boolean,
        condition: ItemCondition,
        category: MarketplaceCategory,
        city: String,
        photos: List<PickedImage>,
    ) -> Unit,
    initialTitle: String = "",
    initialDescription: String = "",
    initialPriceText: String = "",
    initialFree: Boolean = false,
    initialCondition: ItemCondition = ItemCondition.Used,
    initialCategory: MarketplaceCategory = MarketplaceCategory.Other,
    initialCity: String = "",
    // Scopes city autocomplete to the active country so a CA seller isn't offered US municipalities.
    country: Country? = null,
    // Non-null enables a "photos" picker (create mode). Edit keeps photos on the detail screen.
    onPickPhoto: (suspend () -> PickedImage?)? = null,
) {
    var title by remember { mutableStateOf(initialTitle) }
    var description by remember { mutableStateOf(initialDescription) }
    var priceText by remember { mutableStateOf(initialPriceText) }
    var isFree by remember { mutableStateOf(initialFree) }
    var condition by remember { mutableStateOf(initialCondition) }
    var category by remember { mutableStateOf(initialCategory) }
    var city by remember { mutableStateOf(initialCity) }
    var photos by remember { mutableStateOf(emptyList<PickedImage>()) }
    val scope = rememberCoroutineScope()

    val priceCents = parseDollarsToCents(priceText)
    val priceValid = isFree || priceCents != null
    val canSubmit = title.isNotBlank() && priceValid && !submitting

    AppBottomSheet(onDismissRequest = onDismiss, title = sheetTitle) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .verticalScroll(rememberScrollState()),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            // Photos (create mode only) — buffered locally and uploaded after the listing is created
            // (Storage needs the doc to exist). First photo is the main/cover.
            if (onPickPhoto != null) {
                Text(
                    text = stringResource(Res.string.marketplace_sell_photos_label),
                    style = AppTheme.typography.labelMd,
                    color = AppTheme.colors.onSurfaceVariant,
                )
                Row(
                    modifier = Modifier.horizontalScroll(rememberScrollState()),
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                ) {
                    photos.forEachIndexed { index, photo ->
                        Box(
                            modifier = Modifier
                                .size(AppTheme.sizes.avatarXl)
                                .clip(AppTheme.shapes.card)
                                .background(AppTheme.colors.surfaceContainer),
                            contentAlignment = Alignment.Center,
                        ) {
                            // Decode the picked bytes so the seller sees the ACTUAL photo (which one is
                            // the cover, whether they picked the right image) — matches AddBusinessPhotos.
                            val bitmap = remember(photo) {
                                runCatching { photo.bytes.decodeToImageBitmap() }.getOrNull()
                            }
                            if (bitmap != null) {
                                Image(
                                    bitmap = bitmap,
                                    contentDescription = null,
                                    contentScale = ContentScale.Crop,
                                    modifier = Modifier.fillMaxSize(),
                                )
                            } else {
                                AppIcon(name = "image", tint = AppTheme.colors.onSurfaceVariant)
                            }
                            if (index == 0) {
                                StatusBadge(
                                    label = stringResource(Res.string.marketplace_sell_photo_main),
                                    modifier = Modifier.align(Alignment.BottomCenter),
                                )
                            }
                            AppIconButton(
                                iconName = "close",
                                contentDescription = stringResource(Res.string.marketplace_sell_photo_remove),
                                onClick = { photos = photos.filterIndexed { i, _ -> i != index } },
                                modifier = Modifier.align(Alignment.TopEnd),
                            )
                        }
                    }
                    if (photos.size < 8) {
                        val addPhotoLabel = stringResource(Res.string.marketplace_add_photo)
                        Box(
                            modifier = Modifier
                                .size(AppTheme.sizes.avatarXl)
                                .clip(AppTheme.shapes.card)
                                .background(AppTheme.colors.surfaceContainer)
                                .clickable(onClickLabel = addPhotoLabel) {
                                    scope.launch { onPickPhoto()?.let { photos = photos + it } }
                                }
                                .semantics { contentDescription = addPhotoLabel },
                            contentAlignment = Alignment.Center,
                        ) {
                            AppIcon(name = "add_a_photo", tint = AppTheme.colors.primary)
                        }
                    }
                }
            }

            AppTextField(
                value = title,
                onValueChange = { title = it },
                label = stringResource(Res.string.marketplace_sell_title_label),
                placeholder = stringResource(Res.string.marketplace_sell_title_placeholder),
                singleLine = true,
            )
            AppTextField(
                value = description,
                onValueChange = { description = it },
                label = stringResource(Res.string.marketplace_sell_desc_label),
                placeholder = stringResource(Res.string.marketplace_sell_desc_placeholder),
                singleLine = false,
            )

            AppChip(
                label = stringResource(Res.string.marketplace_sell_free),
                selected = isFree,
                leadingIcon = if (isFree) "check" else null,
                onClick = { isFree = !isFree },
            )
            if (!isFree) {
                AppTextField(
                    value = priceText,
                    onValueChange = { priceText = it },
                    label = stringResource(Res.string.marketplace_sell_price_label),
                    placeholder = stringResource(Res.string.marketplace_sell_price_placeholder),
                    singleLine = true,
                    keyboardType = KeyboardType.Decimal,
                )
            }

            Text(
                text = stringResource(Res.string.marketplace_sell_condition_label),
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
            Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                ConditionChoice(ItemCondition.New, stringResource(Res.string.marketplace_condition_new), condition) { condition = it }
                ConditionChoice(ItemCondition.LikeNew, stringResource(Res.string.marketplace_condition_like_new), condition) { condition = it }
                ConditionChoice(ItemCondition.Used, stringResource(Res.string.marketplace_condition_used), condition) { condition = it }
            }

            Text(
                text = stringResource(Res.string.marketplace_sell_category_label),
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
            FlowRow(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm), verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                MarketplaceCategory.entries.forEach { value ->
                    AppChip(
                        label = categoryLabel(value),
                        selected = value == category,
                        onClick = { category = value },
                    )
                }
            }

            CityField(
                value = city,
                onValueChange = { city = it },
                label = stringResource(Res.string.marketplace_sell_city_label),
                placeholder = stringResource(Res.string.marketplace_sell_city_placeholder),
                suggestionsFor = { Metros.suggestCities(it, country) },
            )

            AppButton(
                text = submitLabel,
                onClick = {
                    onSubmit(title, description, priceCents, isFree, condition, category, city, photos)
                },
                modifier = Modifier.fillMaxWidth(),
                enabled = canSubmit,
                loading = submitting,
            )
        }
    }
}

/** Formats integer cents back to an editable dollar string ("1250" → "12.50"); blank when null. */
private fun centsToDollarsText(cents: Long?): String {
    if (cents == null) return ""
    val whole = cents / 100
    val frac = (cents % 100).toInt()
    return if (frac == 0) whole.toString() else "$whole." + frac.toString().padStart(2, '0')
}

@Composable
private fun ConditionChoice(
    value: ItemCondition,
    label: String,
    selected: ItemCondition,
    onSelect: (ItemCondition) -> Unit,
) {
    AppChip(
        label = label,
        selected = value == selected,
        onClick = { onSelect(value) },
    )
}

/** Parses a user-typed dollar amount ("12", "12.5", "12.50", "1,200.00") to integer cents, or null. */
private fun parseDollarsToCents(input: String): Long? {
    val cleaned = input.trim().replace(",", "")
    if (cleaned.isEmpty()) return null
    val value = cleaned.toDoubleOrNull() ?: return null
    if (value < 0) return null
    // Round, not truncate: 19.99 * 100 is 1998.999… in float → toLong() would save $19.98.
    return (value * 100).roundToLong()
}
